import { get } from '../../lib/api'
import { getDemoMode } from '../../hooks/useDemoMode'
import { anonymizeModality, anonymizeModalities } from '../../lib/anonymizer'

const fetch = async (id = {}) => {
  const { data } =
    typeof id === 'string' ? await get(`modalities/${id}`) : await get('modalities', id)
  
  // Apply anonymization if demo mode is enabled
  if (getDemoMode()) {
    if (typeof id === 'string') {
      // Single modality
      return anonymizeModality(data)
    } else {
      // Array of modalities or single object
      if (Array.isArray(data)) {
        return anonymizeModalities(data)
      } else if (data) {
        return anonymizeModality(data)
      }
    }
  }
  
  return data
}

const fetchUsageHistory = async (id) => {
  const { data } = await get(`modalities/usage-history/${id}`)
  return data
}

const fetchCountByVendorAndType = async () => {
  const { data } = await get('modalities/count-by-vendor')
  return data
}

const fetchDashboardMetrics = async (modalityId, filters = {}) => {
  const params = { modalityId: modalityId }
  if (filters.startDate) params.startDate = filters.startDate
  if (filters.endDate) params.endDate = filters.endDate
  
  const { data } = await get('modalities/metrics', params)
  return data
}

export default {
  fetch,
  fetchUsageHistory,
  fetchCountByVendorAndType,
  fetchDashboardMetrics,
}
